module.exports = __webpack_public_path__ + "img/h-1.8243d842.png";